import { useCollapse } from "react-collapsed";
import styled from "styled-components";
import Chevron from "./svgChevron";

interface CollapsibleProps {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Collapse = ({ title, children, className }: CollapsibleProps) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  const chevronDirection = isExpanded ? "up" : "down";

  return (
    <div style={{ overflow: "hidden" }} className={className}>
      <div
        className="bg-brand-backgroundColorThree rounded-md p-[15px] flex items-center"
        {...getToggleProps()}
      >
        <h1 className="text-lg m-0">{title}</h1>
        <Chevron className="ml-auto" animated={true} direction={chevronDirection} />
      </div>
      <div {...getCollapseProps()}>
        <div className="bg-brand-backgroundColorThree mt-4 p-[15px] rounded-md">{children}</div>
      </div>
    </div>
  );
};
